(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentAccessInfoSearch', AgentAccessInfoSearch);

    AgentAccessInfoSearch.$inject = ['$resource'];

    function AgentAccessInfoSearch($resource) {
        var resourceUrl = 'api/_search/agent-access-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
